"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customerOrderPreApi = require("@/api/customerOrderPreApi");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'DetailCardDialog',
  props: {
    programOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fuCardOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      visible: false,
      loading: false,
      resetLoading: false,
      detailData: {},
      assignLogs: [],
      resetLogs: []
    };
  },
  methods: {
    open: function open(row) {
      this.detailData = _objectSpread({}, row);
      this.assignLogs = [];
      this.resetLogs = [];
      this.visible = true;
      this.getDetail(row);
    },
    getDetail: function getDetail(row) {
      var _this = this;
      if (!row || !row.id && !row.batchNo) return;
      this.loading = true;
      (0, _customerOrderPreApi.customerOrderPreDetailApi)({
        id: row.id,
        batchNo: row.batchNo
      }).then(function (res) {
        var data = _this.normalizeDetailData(res);
        _this.detailData = _objectSpread(_objectSpread(_objectSpread({}, _this.detailData), data.baseInfo), data.cardInfo);
        _this.assignLogs = data.assignLogs;
        _this.resetLogs = data.resetLogs;
      }).finally(function () {
        _this.loading = false;
      });
    },
    normalizeDetailData: function normalizeDetailData(res) {
      var data = res && res.data ? res.data : res || {};
      var baseInfo = data.baseInfo || data.preCardInfo || data;
      var cardInfo = data.cardInfo || {};
      var assignLogs = data.assignLogs || data.distributeLogs || data.logs || [];
      var resetLogs = data.resetLogs || [];
      return {
        baseInfo: baseInfo,
        cardInfo: cardInfo,
        assignLogs: Array.isArray(assignLogs) ? assignLogs : [],
        resetLogs: Array.isArray(resetLogs) ? resetLogs : []
      };
    },
    handleClose: function handleClose() {
      this.detailData = {};
      this.assignLogs = [];
      this.resetLogs = [];
    },
    getAvailableCount: function getAvailableCount(row) {
      if (row.canUseTotal !== undefined && row.canUseTotal !== null) return row.canUseTotal;
      if (row.availableCount !== undefined && row.availableCount !== null) return row.availableCount;
      if (!row.cardNoStart || !row.cardNoEnd) return 0;
      return Number(row.cardNoEnd) - Number(row.cardNoStart) + 1;
    },
    getCardNoRangeList: function getCardNoRangeList(cardNoRange) {
      if (cardNoRange === undefined || cardNoRange === null || cardNoRange === '') return [];
      return String(cardNoRange).split(',').map(function (item) {
        return item.trim();
      }).filter(Boolean);
    },
    getProgramNames: function getProgramNames(row) {
      var _this2 = this;
      if (row.availableProgramNames) return row.availableProgramNames;
      var ids = this.getProgramIds(row);
      if (!ids.length) return row.availableProgram || '--';
      var names = ids.map(function (id) {
        var program = _this2.programOptions.find(function (item) {
          return String(item.id) === String(id);
        });
        return program ? program.appName : '';
      }).filter(Boolean);
      return names.length ? names.join('、') : row.availableProgram || '--';
    },
    getProgramIds: function getProgramIds(row) {
      if (Array.isArray(row.availableProgramIds)) return row.availableProgramIds;
      if (typeof row.availableProgram === 'number') return [row.availableProgram];
      if (typeof row.availableProgram === 'string') {
        return row.availableProgram.split(',').map(function (item) {
          return item.trim();
        }).filter(Boolean);
      }
      return [];
    },
    getLogProgramName: function getLogProgramName(row) {
      var appId = row.appId || row.availableProgram;
      if (appId !== undefined && appId !== null && appId !== '') {
        var program = this.programOptions.find(function (item) {
          return String(item.id) === String(appId);
        });
        if (program) return program.appName;
      }
      return row.appName || row.availableProgramName || '--';
    },
    getLogCardName: function getLogCardName(row) {
      var fuCardId = row.fuCardId || row.fu_card_id;
      if (fuCardId !== undefined && fuCardId !== null && fuCardId !== '') {
        var card = this.fuCardOptions.find(function (item) {
          return Number(item.id) === Number(fuCardId);
        });
        if (card) return card.cardName;
      }
      return row.cardName || '--';
    },
    handleResetLog: function handleResetLog(row) {
      var _this3 = this;
      var params = {
        cardNoRange: row.cardNoRange,
        customerOrderId: row.customerOrderId,
        assignLogId: row.id
      };
      if (!params.cardNoRange || !params.customerOrderId) {
        this.$message.warning('缺少卡号段或客户订单ID');
        return;
      }
      this.$confirm("\u786E\u5B9A\u91CD\u7F6E\u5BA2\u6237\u8BA2\u5355\u3010".concat(params.customerOrderId, "\u3011\u7684\u5361\u53F7\u6BB5\u3010").concat(params.cardNoRange, "\u3011\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.resetLoading = true;
        return (0, _customerOrderPreApi.customerOrderPreResetDataApi)(params);
      }).then(function () {
        _this3.$message.success('操作成功');
        _this3.$emit('reset-log', params);
        _this3.getDetail(_this3.detailData);
      }).catch(function () {}).finally(function () {
        _this3.resetLoading = false;
      });
    },
    getStatusText: function getStatusText(status) {
      var statusMap = {
        0: '待制作',
        1: '已制作',
        2: '生成中'
      };
      return statusMap[status] || status || '--';
    },
    getStatusClass: function getStatusClass(status) {
      var classMap = {
        0: 'status-wait',
        1: 'status-done',
        2: 'status-making'
      };
      return classMap[status] || '';
    },
    getLogStatusText: function getLogStatusText(status) {
      var statusMap = {
        '-1': '卡密生成中',
        '-2': '已删除',
        0: '作废',
        1: '已下单',
        2: '已作废',
        3: '已生成订单'
      };
      var statusValue = Number(status);
      return statusMap[statusValue] || status || '--';
    },
    getResetLogStatusText: function getResetLogStatusText(status) {
      var statusMap = {
        0: '已重置'
      };
      var statusValue = Number(status);
      return statusMap[statusValue] || status || '--';
    },
    getLogStatusClass: function getLogStatusClass(status) {
      var classMap = {
        0: 'log-status-success',
        1: 'log-status-primary',
        2: 'log-status-danger',
        3: 'log-status-warn'
      };
      return classMap[Number(status)] || '';
    }
  }
};